
define('ldsh!modules/page_generator/templates/main', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<header class="ed-header js-header header__with__logo"></header>\n<div class="ed-wrapper">\n  <div class="ed-toolbar">\n    <!-- back to info -->\n\n    <div class="js-navigation"></div>\n\n    <div class="ed-toolgroup js-variant-selector"></div>\n  </div>\n\n  <!--preview-->\n  <div class="ed-preview js-preview-container">\n    <div class="ed-hero">\n      <h2 class="ed-loading">\n        <span class="ed-spinner"><span class="ed-icon ed-icon-marquee"></span></span>\n      </h2>\n    </div>\n  </div>\n</div>\n';

}
return __p
};});

